import axios from 'axios';



const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

export default api;


//auto add token to all requests (login form)
api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`; // attach token to request
  }
  return config;
}, 
error => {
  return Promise.reject(error);
});


//session timeout check
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      localStorage.clear(); // simpler cleanup
      window.location.href = '/'; // safe redirect
    }
    return Promise.reject(error); // let components handle it too
  }
);